import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@figure/frontlib-gui';

const Container = styled.div`
  text-align: center;
  margin-top: 30px;
`;

const InstructionButtonGroup = ({ buttonText, handleBack, handleClick }) => (
  <Container>
    <Button secondary onClick={handleBack}>
      Go back
    </Button>

    <Button primary large onClick={handleClick} data-test-id={buttonText.split(" ").join("-").toLowerCase()}>
      {buttonText}
    </Button>
  </Container>
);

InstructionButtonGroup.propTypes = {
  buttonText: PropTypes.string.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default InstructionButtonGroup;
